import { Grid, Typography } from "@mui/material";
import React from "react";
import HeroBg from "../../../assets/landingpage/hero-bg.jpg";
import WelcomeImageWrapper from "./src/welcomeImageWrapper";
import WelcomeTextWrapper from "./src/WelcomeTextWrapper";
import Section from "../../../components/section/section";

const Welcome = (): React.JSX.Element => (
  <Section
    backgroundColor={`
      linear-gradient(to left, 
        rgba(44, 159, 225, 0.8) 0%, 
        rgba(0, 113, 178, 0.8) 100%), 
        url(${HeroBg})`}
  >
    <Grid
      container
      spacing={0}
      sx={{
        color: "white",
        textAlign: {
          xs: "center",
          sm: "left",
        },
      }}
    >
      <Typography
        variant="h1"
        component="h1"
        sx={{
          fontSize: "2.5rem",
          mb: 3,
          wordBreak: "break-word",
        }}
      >
        Starte jetzt dein Bewerbungscoaching im WBS JobMentoring
        Onlinecoaching-Portal
      </Typography>

      <WelcomeTextWrapper />
      <WelcomeImageWrapper />
    </Grid>
  </Section>
);

export default Welcome;
